import { Outlet, useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { SettingsRouteDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import FoldersSettings from 'modules/documents/components/Settings/Folders'
import { useGetFolders } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'

const PublicCompanyFolderIndexPage = () => {
  const { navigation } = useNavigation()

  const { id } = useParams()
  const { loading, folders } = useGetFolders({ ids: [String(id)] })
  const { company } = useCurrentSession()
  const { data: policiesData } = useQuery(SettingsRouteDocument, {
    variables: {},
  })

  const space = SPACES.COMPANY_PUBLIC
  const folder = folders[0]

  if (loading || !id)
    return (
      <Box width="full" alignItems="center">
        <Spinner />
      </Box>
    )

  if (!folder) return <NotFound />

  const canManage = policiesData?.documents._policies.companyManagePublicCompanyFolders.can ?? false

  return (
    <>
      <Outlet
        context={{
          parentRoute: navigation.settings.folders.public.show.fullPath({ id }),
          space,
          companyId: company.id,
          parentFolderId: folder.id,
          rootParentFolderId: folder.rootParentFolder?.id || folder.id,
        }}
      />

      <FoldersSettings
        space={space}
        folderVariables={{ parentFolderId: folder.id }}
        folder={folder}
        canManage={canManage}
        newFolderRoute={navigation.settings.folders.public.show.new.fullPath({ id })}
      />
    </>
  )
}

export default PublicCompanyFolderIndexPage
